// extracted by mini-css-extract-plugin
module.exports = {"figcaption":"image_figcaption__LTZqj","modalImage":"image_modalImage___Tn3w"};